import { useState } from "react";
import { X } from "lucide-react";
import Marquee from "react-fast-marquee";
import { Reveal } from "./Reveal";
import { useSite } from "../context/SiteContext";

export default function GallerySection() {
  const { gallery } = useSite();
  const [active, setActive] = useState(null);

  if (!gallery || gallery.length === 0) return null;

  return (
    <section data-testid="gallery-section" className="bg-forest text-bone py-24 md:py-36 relative overflow-hidden grain">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 relative z-10 mb-14">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Moments</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-none">Campus Gallery</h2>
          <p className="text-bone/50 mt-5 max-w-xl">Glimpses of college life, events and celebrations at Kanggui Christian College.</p>
        </Reveal>
      </div>

      <div className="relative z-10">
        <Marquee speed={38} gradient={false} pauseOnHover className="py-2">
          {gallery.map((g, i) => (
            <button
              key={g.id || i}
              data-testid="gallery-item"
              onClick={() => setActive(g)}
              className="group flex flex-col items-center mx-5 md:mx-8 shrink-0"
            >
              <div className="w-40 h-40 md:w-56 md:h-56 rounded-full overflow-hidden ring-2 ring-gold/40 ring-offset-4 ring-offset-forest shadow-xl">
                <img src={g.image} alt={g.caption || "Campus"} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              </div>
              {g.caption && <span className="mt-4 text-bone/70 text-sm max-w-[14rem] text-center">{g.caption}</span>}
            </button>
          ))}
        </Marquee>
      </div>

      {active && (
        <div data-testid="gallery-lightbox" className="fixed inset-0 z-[60] flex items-center justify-center p-6 bg-forest-900/90 backdrop-blur-sm" onClick={() => setActive(null)}>
          <button className="absolute top-6 right-6 text-bone/70 hover:text-bone" onClick={() => setActive(null)}><X size={30} /></button>
          <figure onClick={(e) => e.stopPropagation()} className="max-w-4xl w-full">
            <img src={active.image} alt={active.caption || "Campus"} className="w-full max-h-[80vh] object-contain rounded-sm" />
            {active.caption && <figcaption className="text-center text-bone/70 mt-4 font-serif text-xl">{active.caption}</figcaption>}
          </figure>
        </div>
      )}
    </section>
  );
}
